export default __webpack_public_path__ + "static/media/Find-a-Dealer.afb6e23e.svg";